import _ from 'lodash';

import * as types from 'PointOfSale/modules/mealTypes/state/types';

export const initialStates = {
  currentSelectedMenu: '',
  currentSelectedTabMenu: 'All Food Items',
  searchText: '',
  foodItems: {},
  fetchingFoodItems: false,

  saveOrderNumFetching: false,
  saveOrderNumError: null,
  saveOrderNumSuccess: false,
};

export default (state = initialStates, { type, payload }) => {
  switch (type) {
    case types.SAVE_ORDER_NUM_ERROR:
      return {
        ...state,
        saveOrderNumError: payload,
      };
    case types.SAVE_ORDER_NUM_FETCHING:
      return {
        ...state,
        saveOrderNumFetching: payload,
      };
    case types.SAVE_ORDER_NUM_SUCCESS:
      return {
        ...state,
        saveOrderNumSuccess: payload,
      };

    case types.SELECT_POS_MEAL_TYPES:
      return {
        ...state,
        currentSelectedMenu: payload.label,
        currentSelectedTabMenu: payload.subMenuTab,
      };
    case types.SELECT_POS_MEAL_TYPES_SUBMENU:
      return {
        ...state,
        currentSelectedTabMenu: payload,
      };
    case types.GET_SERVED_ITEMS_FETCH:
      return {
        ...state,
        foodItems: payload,
      };

    case types.UPDATE_SERVED_ITEMS:
      return {
        ...state,
        foodItems: payload,
      };
    case types.TOGGLE_SERVED_ITEM_SELECTION:
      const { item, selected } = payload;
      const foodItemsClone = _.cloneDeep(state.foodItems);
      _.get(
        foodItemsClone,
        `${state.currentSelectedMenu}.${item.ItemCategoryId}`,
        []
      ).forEach(i => {
        if (i.ItemId === item.ItemId) {
          i.selected = _.isNil(selected) ? !i.selected : selected;
        }
      });

      return {
        ...state,
        foodItems: foodItemsClone,
      };

    case types.SET_SEARCH_TEXT:
      return {
        ...state,
        searchText: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/mealTypes/state/reducer.js